import type { UrlEntry, UrlRegion } from '@/types';

export type ApprenticeshipPages =
  | 'apprenticeship/cy'
  | 'apprenticeship/da'
  | 'apprenticeship/dv'
  | 'apprenticeship/ux'
  | 'apprenticeship/wd';

export const urls: Record<
  ApprenticeshipPages,
  Partial<Record<UrlRegion, UrlEntry>>
> = {
  'apprenticeship/cy': {
    fr: 'alternance/cybersecurite',
  },
  'apprenticeship/da': {
    fr: 'alternance/data-analytics',
  },
  'apprenticeship/dv': {
    fr: 'alternance/devops-cloud-computing',
  },
  'apprenticeship/ux': {
    fr: 'alternance/ux-ui-design',
  },
  'apprenticeship/wd': {
    fr: 'alternance/developpement-web',
  },
};
